import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { t, i18n } = useTranslation('header');
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const currentLang = i18n.language || 'en';
  
  const toggleLanguage = async () => {
    const newLang = currentLang === 'en' ? 'fr' : 'en';
    const currentPath = location.pathname;
    const newPath = currentPath.replace(`/${currentLang}`, `/${newLang}`);
    await i18n.changeLanguage(newLang);
    navigate(newPath);
  };

  const menuItems = [
    { label: t('insurance'), href: 'https://www.neatcar.com/ca/neatcover' },
    { label: t('shop'), href: 'https://shop.neatcar.com/' },
    { label: t('premium'), href: 'https://www.neatcar.com/ca/premium' },
    { label: t('aboutUs'), href: 'https://www.neatcar.com/ca/about-us' },
    { label: t('help'), href: 'https://www.neatcar.com/ca/support' }
  ];

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href={currentLang === 'fr' ? 'https://www.neatcar.com/ca/fr' : 'https://www.neatcar.com/ca'} className="flex items-center">
              <img 
                src="https://www.neatcar.com/resources/assets/logo/neatcar-logo-on-white.png" 
                alt="Neatcar" 
                className="h-8 w-auto"
              />
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex md:items-center md:space-x-8">
            {menuItems.map((item, index) => (
              <a
                key={index}
                href={item.href}
                className="text-gray-700 hover:text-[#52B3D0] transition-colors duration-200 text-sm font-medium"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Right side buttons */}
          <div className="hidden md:flex md:items-center md:space-x-4">
            <button
              onClick={toggleLanguage}
              className="text-gray-700 hover:text-[#52B3D0] transition-colors duration-200 text-sm font-medium"
            >
              {currentLang === 'en' ? 'FR' : 'EN'}
            </button>
            <a
              href="https://www.neatcar.com/ca/send-to-phone"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-full text-white bg-[#2961FF] hover:bg-[#1e4fd9] transition-colors duration-200"
            >
              {t('sendToPhone')}
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-[#52B3D0] hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#52B3D0]"
              aria-expanded={isMenuOpen}
            >
              <span className="sr-only">Open main menu</span>
              {!isMenuOpen ? (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              {menuItems.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  className="text-gray-700 hover:text-[#52B3D0] hover:bg-gray-50 block px-3 py-2 rounded-md text-base font-medium"
                >
                  {item.label}
                </a>
              ))}
              <button
                onClick={toggleLanguage}
                className="text-gray-700 hover:text-[#52B3D0] hover:bg-gray-50 block px-3 py-2 rounded-md text-base font-medium w-full text-left"
              >
                {currentLang === 'en' ? 'Français' : 'English'}
              </button>
              <a
                href="https://www.neatcar.com/ca/send-to-phone"
                className="block px-3 py-2 rounded-full text-base font-medium text-white bg-[#2961FF] hover:bg-[#1e4fd9] text-center"
              >
                {t('sendToPhone')}
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
